import React from 'react';
import { useLanguage } from '../context/LanguageContext';

const Footer = () => {
  const { t } = useLanguage();

  return (
    <footer className="bg-[#0a0a0a] border-t border-gray-800 py-12">
      <div className="max-w-7xl mx-auto px-6">
        <div className="flex flex-col items-center gap-8">
          {/* Logo */}
          <div className="flex items-center gap-3">
            <div className="text-3xl font-light text-[#d4c5a9]">&</div>
            <div className="text-lg font-light tracking-wide text-white">
              GlobalIntel<span className="text-[#d4c5a9]">&</span>Co
            </div>
          </div>

          {/* Legal Mentions */}
          <div className="text-center">
            <p className="text-sm font-semibold text-[#d4c5a9] mb-2">Mentions Légales</p>
            <div className="flex flex-wrap justify-center gap-4 text-sm text-gray-500">
              <span className="flex items-center gap-1">
                🇷🇺 Moscou
              </span>
              <span className="text-gray-700">•</span>
              <span className="flex items-center gap-1">
                🇨🇳 Pékin
              </span>
              <span className="text-gray-700">•</span>
              <span className="flex items-center gap-1">
                🇮🇷 Téhéran
              </span>
              <span className="text-gray-700">•</span>
              <span className="flex items-center gap-1">
                🇰🇵 Pyongyang
              </span>
            </div>
            <p className="text-xs text-gray-600 mt-3 italic">
              Siège social : Kremlin Tower, Red Square, Moscow 103073, Russian Federation
            </p>
          </div>

          {/* Copyright */}
          <div className="text-sm text-gray-500">
            © 2025 GlobalIntel&Co • Tous droits réservés
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;